import { useDisclosure } from "@mantine/hooks";
import { Fragment } from "react";
import { useParams } from "react-router-dom";

import HistoryModal from "../../../../../shared/_Modals/HistoryModal/HistoryModal";
import { Button } from "../../../../../shared/Button/Button";

const MedicalStatementHistory = () => {
  const { userid } = useParams();
  const [opened, { open, close }] = useDisclosure();

  const handleOpenHistory = () => {
    open();
  };
  return (
    <Fragment>
      <Button variant="outline" onClick={handleOpenHistory}>
        History
      </Button>
      <HistoryModal
        opened={opened}
        close={close}
        hideAutosave
        requestBody={{
          request: "get-med-card-history",
          body: {
            params: {
              userid,
            },
          },
        }}
      />
    </Fragment>
  );
};
export default MedicalStatementHistory;
